export const LIST_EXAMWORDS = "LIST_EXAMWORDS";
export const CREATE_EXAMWORD = "CREATE_EXAMWORD";
export const UPDATE_EXAMWORD = "UPDATE_EXAMWORD";
export const DELETE_EXAMWORD = "DELETE_EXAMWORD";
export const DETAIL_EXAMWORD = "DETAIL_EXAMWORD";
export const SHOW_EXAMWORD = "SHOW_EXAMWORD";
export const ADD_DELETE = "ADD_DELETE";
export const CHECK_ALL = "CHECK_ALL";
export const COPY_EXAMWORD = "COPY_EXAMWORD";
export const UPLOAD_FILE = "UPLOAD_FILE";
export const DOWNLOAD_FILE = "DOWNLOAD_FILE";
export const LIST_CLASS = "LIST_CLASS_WORD";
export const REPORT_CLASS = "REPORT_CLASS_WORD";
export const SET_EXAM_DETAIL = "SET_EXAM_DETAIL";
export const LIST_CLASSROOMS = "LIST_CLASSROOMS";
export const EXPORT_WORD = "EXPORT_WORD";